import { Routes } from '@angular/router';
import { AuthGuard } from './shared/services/guard/auth.guard';
import { AdminLayoutComponent } from './shared/components/layouts/admin-layout/admin-layout.component';

export const rootRouterConfig: Routes = [
	{
		path: '',
		redirectTo: 'login',
		pathMatch: 'full'
	},
	{
		path: 'login',
		loadChildren: () => import('./views/login/login.module').then(m =>
			m.LoginModule)
	},
	{
		path: 'dashboard',
		component: AdminLayoutComponent,
		loadChildren: () => import('./views/dashboard/dashboard.module').then(m =>
			m.DashboardModule)
	},
	{
		path: '**',
		redirectTo: 'login',
		pathMatch: 'full'
	}
];

